import React from 'react'

const FeatureLocked = () => {
  return (
    <div>Complete 150 leetcode question to get resume review</div>
  )
}

export default FeatureLocked